import React from "react"
import { VariantReader } from "aldoo-ra/VariantReader"
import { twMerge } from "tailwind-merge"

const currencySymbols = {
  eur: "€", usd: "$", gbp: "£", jpy: "¥", chf: "CHF", cny: "¥", inr: "₹", rub: "₽",
}

const currencySymbol = (currency) =>
  currencySymbols[currency?.toLowerCase()] || currency?.toUpperCase() || ""

/**
 * Unified price display: amount in cents (divisor 100) or coins (currency "coins").
 * variant: small | medium | large
 */
export default function PriceDisplay({
  amount,
  currency,
  divisor = 100,
  variant = "medium",
  size,
  className = "",
  styleOverrides,
  struck = false,
}) {
  const v = VariantReader.useVariant({
    componentName: "PriceDisplay",
    variant: size || variant,
    styleOverrides,
  })
  const isCoins = currency?.toLowerCase() === "coins"
  const value = isCoins ? amount : amount / divisor
  const [whole, fraction] = isCoins ? [String(value), null] : Number(value).toFixed(2).split(".")
  const struckCls = struck ? "line-through decoration-1" : ""

  return (
    <span className={twMerge(v.container, isCoins && "min-w-0 gap-2", className)}>
      {isCoins ? (
        <img src="/static/p-images/coin--28x28.webp" alt="aldoo-credits" className={v.coin} />
      ) : (
        <span className={twMerge(v.currency, struckCls)}>{currencySymbol(currency)}</span>
      )}
      <span className="inline-flex items-start">
        <span className={twMerge(v.whole, struckCls)}>{whole}</span>
        {!isCoins && (
          <>
            <span className={twMerge(v.decimal, struckCls)}>.</span>
            <span className={twMerge(v.fraction, struckCls)}>{fraction}</span>
          </>
        )}
      </span>
    </span>
  )
}
